import React from 'react';
import { intl } from 'ehs-react';
import { usePortletStore } from '../../App';

export const Imprint = () => {
  const [hasImprint] = usePortletStore(state => [
    state.configuration.hasImprint
  ]);

  return hasImprint ? (
    <>
      {/* {@link imprint.ts} */}
      <a id="login-imprint" className="login-imprint" tabIndex={0}>
        {intl('portalsetupparameters.guest.imprint_layout.name')}
      </a>
    </>
  ) : null;
};
